import { collection, getDocs, query, limit } from "firebase/firestore";
import { db } from "../firebase";

/** Pick first candidate with docs, else first readable (may be empty). */
export async function resolveCollectionName(candidates) {
  if (!candidates?.length) return null;
  const results = await Promise.all(
    candidates.map(async (cName) => {
      try {
        const snap = await getDocs(query(collection(db, cName), limit(1)));
        return { cName, snap, ok: true };
      } catch {
        return { cName, snap: null, ok: false };
      }
    })
  );
  const byName = new Map(results.map((r) => [r.cName, r]));
  for (const cName of candidates) {
    const r = byName.get(cName);
    if (r?.ok && r.snap?.size > 0) return cName;
  }
  for (const cName of candidates) {
    const r = byName.get(cName);
    if (r?.ok) return cName;
  }
  return null;
}
